import { NgModule } from '@angular/core';
import { SPXDataFilterComponent } from './components/datafilter/datafilter.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SafeHtmlPipe } from './components/common/safe-html.pipe';
import { StripHtmlPipe } from './components/common/strip-html.pipe';


@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
  ],
  declarations: [
    SPXDataFilterComponent,
    SafeHtmlPipe,
    StripHtmlPipe,
    ],
  exports: [
    SPXDataFilterComponent,
    SafeHtmlPipe,
    StripHtmlPipe,
    ]
})
export class BambooModule { }
